import WolfyEmitter from 'wolfy87-eventemitter';
import applyMixins from './apply-mixins';
class ExtendedEmitter extends WolfyEmitter {
    hasListener(event, listener) {
        return this.getListeners(event).some((item) => item.listener === listener);
    }
    addListenerIfNotExists(event, listener) {
        if (!this.hasListener(event, listener)) {
            this.addListener(event, listener);
        }
    }
}
export default class EventEmitter extends ExtendedEmitter {
}
applyMixins(EventEmitter, [ExtendedEmitter, WolfyEmitter]);
